// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_9e1425b4d3--tabs--dXDos"};